<script setup>
import UseSvg from "common/vue/components/UseSvg.vue";

const props = defineProps({
  message: {
    type: String,
    required: true
  }
});
</script>

<template>
  <div class="artwork-error">
    <div class="artwork-error__icon">
      <UseSvg icon="warning" />
    </div>

    <div class="artwork-error__message">
      {{ props.message }}
    </div>
  </div>
</template>

<style scoped lang="scss">
@import "frontend/init/jiffy/mixin";
@import "frontend/init/jiffy/print-settings";

.artwork-error {
  display: flex;
  background: $red-error-background-2;
  padding: 8px;
  font-size: 12px;
  color: $red-light;
  align-items: center;
  border-radius: 4px;

  &__icon {
    @include svg-wrapper;

    width: 21px;
    height: 21px;
    margin-right: 8px;
  }

  &__message {
    flex: 1;
  }
}
</style>
